import { cloneDeep, Dictionary, filter, get, isEmpty, keyBy, map, mapValues } from "lodash"
import { Activity, OrderPosition, ProductionOrder, TimelinePlanningObject } from "~/sagas/timelines/TimelineSagaTypes"
import { User } from "~/types/api/UserTypes"

export const addOwner = (planningObjects: Dictionary<TimelinePlanningObject>, users: User[]) => {
  const userMap = keyBy(users, "userId")

  const getUsername = (ownerId: number) => {
    const user = userMap[ownerId]
    return user ? [user.firstName, user.lastName].filter(Boolean).join(" ") : ""
  }

  const updatedPlanningObjects = mapValues(planningObjects, planningObject => {
    const objectOwner = getUsername(planningObject.ownerId)
    const updatedPlanningObject = {
      ...planningObject,
      owner: objectOwner,
    }

    const initialOrderPositions = filter(
      get(planningObject, "orderPositions", [] as OrderPosition[]),
      "orderPositionId"
    )

    if (!isEmpty(initialOrderPositions)) {
      const orderPositions = map(initialOrderPositions, orderPosition => {
        const orderPositionOwner = getUsername(orderPosition.ownerId)

        const updatedOrderPosition = {
          ...orderPosition,
          owner: orderPositionOwner,
        }

        if (orderPosition.activities) {
          const activities = map(get(orderPosition, "activities", [] as Activity[]), activity => {
            const updatedActivity = cloneDeep(activity)

            if (activity.productionOrders) {
              const productionOrders = map(
                get(activity, "productionOrders", [] as ProductionOrder[]),
                productionOrder => {
                  const productionOrderOwner = getUsername(productionOrder.ownerId)
                  return {
                    ...productionOrder,
                    owner: productionOrderOwner,
                  }
                }
              )
              updatedActivity.productionOrders = productionOrders
            }

            return updatedActivity
          })
          updatedOrderPosition.activities = activities
        }

        return updatedOrderPosition
      })
      updatedPlanningObject.orderPositions = orderPositions
    }

    return updatedPlanningObject
  })
  return updatedPlanningObjects
}
